import React from 'react'

import { useAppContext } from 'context/AppContext'
import { useUser } from 'hooks'

import AppBar from './components/AppBar'
import Footer from '../components/Footer'
import Head from '../components/Head'

import classes from './Home.module.scss'

/** @type {import('./types').default} */
const HomeLayout = ({ children }) => {
  const { head, url, hreflangs } = useAppContext()
  const [user] = useUser()
  const hasHead = head && Object.keys(head).filter(key => key !== 'google_analytics').length > 0
  return (
    <>
      {hasHead && <Head metaData={head} url={url} hreflangs={hreflangs} />}
      <AppBar className="Header" user={user} />
      <main className={classes.white}>{children}</main>
      <Footer isSignedIn={!!user} />
    </>
  )
}

export default HomeLayout
